if (!customElements.get('koko-balm-highlight')) {
  customElements.define('koko-balm-highlight', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const buttons = [...this.querySelectorAll('[data-benefit]')];
      const slides = [...this.querySelectorAll('[data-slide]')];
      const hover = matchMedia('(hover: hover) and (pointer: fine)');
      let current = slides.findIndex(slide => slide.classList.contains('is-visible'));
      const select = (index, touch = false) => {
        buttons.forEach((button, i) => {
          button.setAttribute('aria-pressed', String(i === index));
          button.classList.toggle('is-touched', touch && i === index);
        });
        if (current === index) return;
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-previous', i === current);
          slide.classList.toggle('is-visible', i === index);
          slide.classList.remove('is-entering');
          slide.setAttribute('aria-hidden', String(i !== index));
        });
        // Restart the slide entrance even during rapid changes between words.
        void slides[index].offsetWidth;
        slides[index].classList.add('is-entering');
        current = index;
      };
      buttons.forEach((button, index) => {
        button.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse' || !hover.matches) return;
          button.classList.add('is-hovered');
          select(index);
        }, { signal });
        button.addEventListener('pointerleave', () => button.classList.remove('is-hovered'), { signal });
        button.addEventListener('click', event => select(index, event.pointerType === 'touch' || !hover.matches), { signal });
        button.addEventListener('focus', () => {
          if (button.matches(':focus-visible')) select(index);
        }, { signal });
      });
      this.addEventListener('shopify:block:select', event => {
        const button = event.target.querySelector('[data-benefit]');
        if (button) select(Number(button.dataset.benefit));
      }, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
